<template>
	<div class="list-item">
		<slot></slot>
	</div>
</template>